import { type DataTypeProvider } from "@devexpress/dx-react-grid";

export const Number = ({
  column,
  row,
}: DataTypeProvider.ValueFormatterProps) => {
  return (
    <div className="px-2 flex justify-end items-center w-full h-full">
      {Math.trunc(row[column.name])}
    </div>
  );
};
